import { combineReducers } from 'redux';
import onboardingReducer from './onboarding';
import propertyReducer from './property';
import configReducer from './config';
import notificationReducer from './notification';
import stackedNotificationsReducer from '@common/reducers/stackedNotifications';

const landlordReducer = combineReducers({
  onboarding: onboardingReducer,
  property: propertyReducer,
  config: configReducer,
  notification: notificationReducer,
  stackedNotifications: stackedNotificationsReducer,
});

export { landlordReducer };
